var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    !_vm.isFilterOptionsOpened
      ? _c(
          "div",
          { staticClass: "search-sort-block m-auto d-flex flex-wrap" },
          [
            _c(
              "div",
              { staticClass: "search-block" },
              [
                _c("search-input", {
                  attrs: {
                    "search-block-style": "search-gallery-block-styles",
                    "input-classes": "search-gallery-input",
                    "button-style": "p-0 search-icon-button",
                    iconsize: "15",
                    isInspiration: true,
                    iconcolor: "#000",
                    "placeholder-value": "Search Within Inspiration",
                    "on-input": _vm.onSearchInput,
                    value: _vm.searchTerm
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sort-block d-flex justify-content-end" },
              [
                _c("div", { staticClass: "select-label" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString["product.search.display.sort.by"]
                      ) + ":"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "\n          wf-product-display-control\n          inspiration-product-display-control-sort-by\n        "
                  },
                  [
                    _c(
                      "select",
                      {
                        staticClass: "custom-select gallery-select",
                        attrs: {
                          name: "inspiration-product-display-control-sort-by"
                        },
                        on: { change: _vm.setOrdering }
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$resourceString[
                                  "product.search.display.sort.by"
                                ]
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: { value: "DisplayCollectionName asc" },
                            domProps: {
                              selected:
                                _vm.sortOrder + " " + _vm.isAscendingOrder ===
                                "DisplayCollectionName asc"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.search.display.sort.by.alphabet"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: { value: "DisplayCollectionName desc" },
                            domProps: {
                              selected:
                                _vm.sortOrder + " " + _vm.isAscendingOrder ===
                                "DisplayCollectionName desc"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.search.display.sort.by.za"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: { value: "RoomType" },
                            domProps: {
                              selected: "" + _vm.sortOrder === "RoomType"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "inspiration.display.control.sort.by.room"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: { value: "InspirationType" },
                            domProps: {
                              selected: "" + _vm.sortOrder === "InspirationType"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "inspiration.display.control.sort.by.inspiration"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: { value: "ProjectType" },
                            domProps: {
                              selected: "" + _vm.sortOrder === "ProjectType"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "inspiration.display.control.sort.by.projects"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }